import { Paper } from '../common/paper';
import { Card } from '@mui/material';
import React, { ReactNode } from 'react';

interface DialogContainerProps {
  children: ReactNode;
  maxWidth?: string | number;

}

const DialogContainer = ({ children, maxWidth = '400px' }: DialogContainerProps) => {
  return (
    <Paper
      sx={{
        borderRadius: 1,
        overflow: 'hidden',
        width: '100%',
        maxWidth: maxWidth,
        maxHeight: '100%',
        display: 'flex',
        flexDirection: 'column',
        bgcolor: 'background.paper'
      }}
    >
      {children}
    </Paper>
  );
};

export default DialogContainer; 